export default "__VITE_ASSET__DxOtO55a__"